import {Component, Inject, inject, OnInit} from '@angular/core';
import {
  DynamicFormService
} from "../../../../../../shared/components/dynamic-forms-components/dynamic-form.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {UntypedFormGroup} from "@angular/forms";
import {FieldConfig} from "../../../../../../shared/components/dynamic-forms-components/field.interface";
import * as fromConfigs from "./warehouse-sensor-add.form";
import { AppState } from '../../../../../../store';
import { Store } from '@ngrx/store';
import { StoreItemActions } from '../../../../../../store/entities/store-item/store-item.actions';
import { StoreItemEntity } from '../../../../../../store/entities/store-item/store-item.model';
import { CREATE_WAREHOUSE_SENSOR_MUTATION, UPDATE_WAREHOUSE_SENSOR_MUTATION } from '../../../../../../store/entities/warehouse-management/device/device.graphql';
import { ActivatedRoute } from '@angular/router';
import {AttachmentService} from "../../../../../../services/attachment.service";
import {isBase64} from "../../../../../../shared/helpers/functions.helper";

@Component({
  selector: 'app-zone-sensor-add',
  templateUrl: './warehouse-sensor-add.component.html',
  styleUrl: './warehouse-sensor-add.component.scss'
})
export class WarehouseSensorAddComponent implements OnInit {

  private dynamicFormService: DynamicFormService = inject(DynamicFormService)
  private attachmentService: AttachmentService = inject(AttachmentService)
  private dialogRef: MatDialogRef<WarehouseSensorAddComponent> = inject(MatDialogRef<WarehouseSensorAddComponent>)
  private warehouseId: string;

  constructor(private store: Store<AppState>,private route: ActivatedRoute,@Inject(MAT_DIALOG_DATA) public data){
    this.warehouseId = this.data?.warehouse
  }
  supportForm: UntypedFormGroup;

  sensorFields: FieldConfig[] = fromConfigs.sensorFields;
  title: string;
  loading: boolean = false;


  ngOnInit() {
    this.warehouseId = this.data?.warehouse || this.route.snapshot.queryParams["id"];
    this.supportForm = this.dynamicFormService.createControl(this.sensorFields, { ...this.data, warehouse: this.warehouseId });
}

  submitForm(formData: any) {
    this.loading = true;
    const posPictureBase64 = formData?.posPicture?.base64;
    const fileName = formData?.serialNumber || 'sensor_photo';

    if (posPictureBase64) {
      const base64Data = posPictureBase64.split(',')[1];
      // if (!isBase64(base64Data)) {
      //   this.loading = false;
      //   console.error("Invalid base64 format for posPicture");
      //   return;
      // }

      this.attachmentService
          .saveAttachment(base64Data, fileName)
          .then((uploadResult) => {
            // Update formData with the returned file path
            formData.posPicture = uploadResult.filePath;
            // Send the updated form data
            this.dispatchForm(formData);
          })
          .catch((error) => {
            console.error("Photo upload failed:", error);
            this.loading = false;
          });
    } else {
      // If no photo is provided, directly send the form data
      this.dispatchForm(formData);
    }
  }

  private dispatchForm(formData: any) {
    this.store.dispatch(StoreItemActions.createUpdateStoreItem({
      entity:StoreItemEntity.device,
      mutation:this.data?.uniqueId? UPDATE_WAREHOUSE_SENSOR_MUTATION : CREATE_WAREHOUSE_SENSOR_MUTATION,
      isInput:true,
      input:{
        ...formData,
        warehouse: this.warehouseId,
        uniqueId:this.data?.uniqueId
      }
        })
    );

    this.loading = false;
    this.closeDialog();
  }
  closeDialog() {
    this.dialogRef.close();
  }
}
